import { createContext } from "react";
import Delta from "quill-delta";

const messageCallbacks: ((
  pid: string,
  content: string | Delta | undefined,
  postion: "after" | "before" | "replace" | "none",
  focus?: boolean
) => void)[] = [];

export function onMessage(
  fn: (
    pid: string,
    content: string | Delta | undefined,
    postion: "after" | "before" | "replace" | "none",
    focus?: boolean
  ) => void
) {
  messageCallbacks.push(fn);
  return () => {
    messageCallbacks.splice(messageCallbacks.indexOf(fn), 1);
  };
}

export function sendMessage(
  pid: string,
  content: string | Delta | undefined,
  postion: "after" | "before" | "replace" | "none" = "after",
  focus?: boolean
) {
  messageCallbacks.forEach((fn) => fn(pid, content, postion, focus));
}

export const AppContext = createContext({
  onMessage,
});
